import { Capacitor, registerPlugin } from '@capacitor/core';
import { calculateMatchStats, comparePlayers } from './matchStats';

// Native side: android/app/src/main/java/uk/co/padelmvp/app/widget/WidgetBridgePlugin.kt
const PadelWidget = registerPlugin('PadelWidget');

export const isAndroidApp = () => Capacitor.getPlatform?.() === 'android';

const httpUrl = (url) => (typeof url === 'string' && /^https?:\/\//.test(url) ? url : null);

function photoFor(club, name) {
  const lower = name.toLowerCase();
  const player = (club.players || []).find((p) => (typeof p === 'object' ? p?.name : p)?.toLowerCase?.() === lower);
  if (player && typeof player === 'object' && httpUrl(player.photoUrl)) return player.photoUrl;
  const member = Object.values(club.members || {}).find((m) => m?.name?.toLowerCase() === lower);
  return httpUrl(member?.photoUrl);
}

/**
 * One club's overall standings for the home-screen widget: the same numbers and order as the
 * Stats tab's OVERALL table. M = match wins minus losses, G = games won minus lost.
 */
export function clubStandingsForWidget(club, archivedSessions = []) {
  const players = Object.values(calculateMatchStats(archivedSessions))
    .filter((p) => p.w + p.l + p.gw + p.gl > 0)
    .sort(comparePlayers)
    .map((p) => ({
      name: p.name,
      photoUrl: photoFor(club, p.name),
      matchDiff: p.w - p.l,
      gameDiff: p.gw - p.gl,
      mvp: p.mvp,
    }));
  return { id: club.id, name: club.name || 'Club', photoUrl: httpUrl(club.photoUrl), players };
}

/** Hands every club's standings to the Android widget. No-op on iOS and the web. */
export async function saveWidgetStandings(clubs) {
  if (!isAndroidApp()) return;
  try {
    await PadelWidget.saveStandings({ updatedAt: Date.now(), clubs });
  } catch (err) {
    console.warn('[PadelMVP] Widget standings not saved:', err);
  }
}
